import { render, staticRenderFns } from "./TabProductsReservation.vue?vue&type=template&id=687f000f&"
import script from "./TabProductsReservation.vue?vue&type=script&lang=ts&"
export * from "./TabProductsReservation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('687f000f', component.options)
    } else {
      api.reload('687f000f', component.options)
    }
    module.hot.accept("./TabProductsReservation.vue?vue&type=template&id=687f000f&", function () {
      api.rerender('687f000f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/TabsModals/Products/TabProductsReservation.vue"
export default component.exports